import React from 'react';

import { Container } from './styles';

import DropdownSp from '../../../../components/DropdownSp';

function Dropdown(props) {
  const { required, ...rest } = props;

  return (
    <Container required={required}>
      <DropdownSp className={required ? 'required' : ''} {...rest} />
    </Container>
  );
}

export default Dropdown;
